import { render, staticRenderFns } from "./TimeToResolutionCard.vue?vue&type=template&id=30d3bb51&"
import script from "./TimeToResolutionCard.vue?vue&type=script&lang=js&"
export * from "./TimeToResolutionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports